import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HydraoApiService } from "src/app/core/services/core/hydrao-api.service";
import {
  AlertDefinition,
  AlertDefinitionAdapter,
} from "../models/alert-definition.model";

@Injectable({
  providedIn: "root",
})
export class AlertDefinitionService extends HydraoApiService<AlertDefinition> {
  private _alertDefinitionAdapter: AlertDefinitionAdapter = inject(
    AlertDefinitionAdapter
  );

  public getAlertDefinitionsForStore(): Observable<AlertDefinition[]> {
    let url = "/alert-definitions";

    return this.get(
      url,
      this._alertDefinitionAdapter,
      false,
      true
    ) as Observable<AlertDefinition[]>;
  }

  public addAlertDefinitionForStore(
    definition: AlertDefinition
  ): Observable<AlertDefinition> {
    let url = `/alert-definitions`;

    return this.post(
      url,
      definition.toJSON(),
      this._alertDefinitionAdapter,
      false
    );
  }

  public updateAlertDefinitionForStore(
    definition: AlertDefinition
  ): Observable<AlertDefinition> {
    let url = `/alert-definitions/${definition.id}`;

    return this.put(
      url,
      definition.toJSON(),
      this._alertDefinitionAdapter,
      false
    );
  }

  public batchUpdateAlertDefinitionsForStore(
    alertDefIds: number[],
    props: any
  ): Observable<Boolean> {
    let url = `/alert-definitions/bulk-update`;

    return this.rawPost(
      url,
      {
        ids: alertDefIds,
        ...props,
      },
      false
    );
  }

  public deletAlertDefinitionForStore(
    definitionId: number
  ): Observable<AlertDefinition> {
    let url = `/alert-definitions/${definitionId}`;

    return this.delete(url, false);
  }

  // public updateAlertDefinition(
  //   alertDef: AlertDefinition
  // ): Observable<AlertDefinition> {
  //   let url = `/alert-definitions/${alertDef.id}`;

  //   return this.put(url, alertDef.toJSON(), this._alertDefinitionAdapter).pipe(
  //     delayWhen(() =>
  //       forkJoin([
  //         this.emptyCache(),
  //         this._alertService.emptyCache(),
  //         this._placeService.emptyPlaceAnomaliesCache(),
  //       ])
  //     )
  //   );
  // }

  // public createAlertDefition(
  //   alertDef: AlertDefinition
  // ): Observable<AlertDefinition> {
  //   let url = `/alert-definitions`;

  //   return this.post(url, alertDef.toJSON(), this._alertDefinitionAdapter).pipe(
  //     delayWhen(() =>
  //       forkJoin([
  //         this.emptyCache(),
  //         this._alertService.emptyCache(),
  //         this._placeService.emptyPlaceAnomaliesCache(),
  //       ])
  //     )
  //   );
  // }

  // public deletAlertDefinition(alertDefId: number): Observable<AlertDefinition> {
  //   let url = `/alert-definitions/${alertDefId}`;

  //   return this.delete(url).pipe(
  //     delayWhen(() =>
  //       forkJoin([
  //         this.emptyCache(),
  //         this._alertService.emptyCache(),
  //         this._placeService.emptyPlaceAnomaliesCache(),
  //       ])
  //     )
  //   );
  // }
}
